import { backendApi } from "@/services/backend/api";
import { Order } from "@/services/backend/htz/orders/types/order";
import { Filter } from "@/shared/lib/filter/filter";
import {
  providesEntity,
  providesList,
} from "@/services/backend/_lib/tag-helpers";
import {
  DocumentBaseFilters,
  DocumentCommonFilters,
} from "@/services/backend/documents/types/filters";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { Lst } from "@/shared/lib/lst/lst";

const orderApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    htzOrderPut: build.mutation<Order, PutRequest>({
      query: (request) => ({
        url: `/htz/order`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: (_result, _e, request) => [
        { type: "HtzOrder", id: request.id },
        "HtzOrder",
      ],
    }),
    htzOrderShow: build.query<Order, ShowRequest>({
      query: (request) => ({
        url: `/htz/order`,
        method: "GET",
        params: request,
      }),
      providesTags: providesEntity("HtzOrder"),
    }),
    htzOrderList: build.query<Lst<Order>, ListRequest>({
      query: (request) => ({
        url: `/htz/order/list`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) => providesList(result?.items, "HtzOrder"),
    }),
    htzOrderDelete: build.mutation<null, DeleteRequest>({
      query: (request) => ({
        url: `/htz/order`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["HtzOrder"],
    }),
  }),
});

export const {
  useHtzOrderPutMutation,
  useHtzOrderShowQuery,
  useHtzOrderListQuery,
  useLazyHtzOrderListQuery,
  useHtzOrderDeleteMutation,
} = orderApi;

export type PutRequest = Order;

export interface ShowRequest {
  id: string;
}

export interface ListRequest
  extends DocumentBaseFilters, DocumentCommonFilters {
  orderBy?: OrdrBy<string>[];
  date?: Filter<string>;
  limit?: number;
  offset?: number;
}

export interface DeleteRequest {
  id: string;
}
